<template>
	<div
		v-if="loadingCompleted"
		id="panel_useful"
		class="panel useful"
	>
		<div v-if="noContent">
			<div class="container">
				{{ $t('noContent') }}
			</div>
			<courses :no-content="noContent" />
		</div>

		<div v-else class="container">
			<div class="panel_header">
				<div class="row align-items-end">
					<div class="col-12 col-lg-6">
						<h2>{{ $t('content') }} {{ author.name_genitive }}</h2>
					</div>
					<div class="col-12 col-lg-6">
						<div class="swiper_menu">
							<div v-swiper:menuSwiper="options">
								<div class="swiper-wrapper">
									<div
										v-for="[typeId, label] in announceButtons"
										:key="typeId"
										class="swiper-slide"
									>
										<button
											:class="{active: announceActiveButtons[typeId]}"
											@click="loadUsefulContent(typeId)"
										>
											{{ label }}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div
					v-for="(item, index) in usefulContentData.data"
					:key="index"
					class="col-12 col-md-6 col-lg-4 mb-4"
					:class="{'d-none d-md-block d-lg-none' : index === 9}"
				>
					<div :class="'useful-item ' + contentIconMap[item.content_type]">
						<div>
							<div class="useful-item_top">
								<div class="tag_string">
									<template v-for="(person, key) in item.people">
										<span
											v-if="item.people !== null"
											:key="key"
										>
											{{ person.title }}
										</span>
									</template>
								</div>
								<div class="date">
									{{ item.date | moment("DD MMMM YYYY") }}
								</div>
							</div>
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								class="title"
							>
								{{ item.title }}
							</nuxt-link>
						</div>
						<div v-if="item.content_type === 1" class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('watch') }}
							</nuxt-link>
						</div>
						<div v-else-if="item.content_type === 2" class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('listen') }}
							</nuxt-link>
						</div>
						<div v-else-if="item.content_type === 0" class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('read') }}
							</nuxt-link>
						</div>
						<div v-else class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('more') }}
							</nuxt-link>
						</div>
					</div>
				</div>
				<!-- Четвертый элемент d-lg-none -->
			</div>
			<!--<div class="panel_footer">
		<div class="row">
			<div class="col-12 col-md-4 col-lg-3">
			<a href="/sp/anti-fragility/article/" class="btn btn-primary">Весь полезный контент</a>
			</div>
			<div class="col-12 col-md-8 col-lg-6 offset-lg-4">
			</div>
		</div>
		</div>-->
		</div>
	</div>
</template>

<script>
import '@/utils/moment';
import Courses from '~/pages/user/profile/courses.vue';

import {
	Swiper,
	SwiperSlide,
	directive,
} from 'vue-awesome-swiper';

export default {
	name: 'IssueUsefulContentPanel',
	components: {
		Swiper,
		SwiperSlide,
		Courses,
	},
	directives: {
		swiper: directive,
	},
	props: [
		'content',
		'block_title',
		'listData',
		'author',
	],
	data() {
		return {
			// seen: true,
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				// freeMode: true,
				loop: false,
			},
			usefulContentData: [],
			contentTypeMap: {
				0: 'Статья',
				1: 'Видео',
				2: 'Подкаст',
			},
			contentIconMap: {
				0: 'text',
				1: 'video',
				2: 'audio',
			},
			activeClass: 'active',
			announceActiveButtons: {
				'': true,
			},
			announceButtons: [
				['', this.$t('all')],
				['0', this.$t('media')],
				['1', this.$t('video')],
				['2', this.$t('podcast')],
			],
			noContent: true,
			loadingCompleted: false,
		};
	},
	computed: {
		contentArticle() {
			return this.usefulContentData.data.filter((i) => i.taxonomy_type !== 1);
		},
	},
	created() {
		// this.seen = false;
		this.loadingCompleted = false;
		this.$axios
			.get(`${process.env.baseURL}/api/content/list?page_size=6&order_by=desc&people_slug=${this.author.slug}`)
			.then((res) => {
				this.usefulContentData = res.data;
				this.loadingCompleted = true;
				if (!this.usefulContentData.data.length) {
					this.noContent = true;
				} else {
					this.noContent = false;
					// this.seen = true;
				}
				// this.noContent = this.usefulContentData?.data?.length;
				// if (this.usefulContentData.data.length) {
				// 	this.seen = true;
				// }
			});
	},
	methods: {
		loadUsefulContent(announceType) {
			this.announceActiveButtons = {};
			this.announceActiveButtons[announceType] = true;
			this.$axios
				.get(`${process.env.baseURL}/api/content/list?page_size=6&order_by=desc&people_slug=${this.author.slug}&content_type=${announceType}`)
				.then((res) => {
					this.usefulContentData = res.data;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~/assets/styles/components/blocks/issue-useful-content-panel';
</style>
